<template>
<div id="ResetPassword">
  <h3 class="title-text">Reset Password</h3>
  <div class="contact-area" v-if="codeIsValid">
    <p class="sub-auth-text">Your account has been verified!</p>
    <p class="feedback" v-if="status == 'success'">{{feedback}}</p>

    <div class="login-form"  v-else-if="!processing">

    <div class="input-group">
      <img src="@/assets/icons/lock.svg" class="input-icon"/>

      <input class="login-input long"
       type="password" v-model="password" placeholder="New Password"  /><br />
    </div>

    <div class="input-group">
      <img src="@/assets/icons/lock.svg" class="input-icon"/>

      <input class="login-input long"
      type="password" v-model="password2" placeholder="Confirm Password" /><br />
    </div>

      <button class="login-btn" @click="updatePassword(reset_token)">Reset</button>
      <br />

    <p>If you have any issues feel free to contact support:
      <a href="https://heybuddy.club/pages/contact-us" target="_blank" class="contact-text">Contact US</a>
    </p>
    
    </div>

    <div class="processing-box" v-else-if="processing">
      <img src="@/assets/gifs/barkbadge-loading-250px.gif"/>
    </div>
  </div>
  <div v-else class="contact-area">
    <p>Reset Code is valid</p>
  </div>
</div>
</template>
<script>
// import axios from 'axios'
import {fb} from '@/_firebase/init'
// import {mapState, mapActions} from 'vuex'

export default{
  props:['isMobile'],
  name: 'ResetPassword',
data(){
  return{
    reset_token: this.$route.query.oobCode,
    user_id: '',
    password:'',
    password2: '',
    feedback: '',
    processing: false,
    status: '',
    codeIsValid: false,
  }
},
methods:{
  verifyPasswordCode(code){
    fb.auth().verifyPasswordResetCode(code)
    .then((email) =>{
      // Display a "new password" form with the user's email address
      console.log(email)
      this.codeIsValid = true
    })
    .catch((err) => {
      // Invalid code
      this.feedback == 'Invalid Code'
      this.codeIsValid = false
      console.log(err)
    })
  },
  updatePassword(code){
    this.processing = true
    if(this.password == this.password2){
    fb.auth().confirmPasswordReset(code, this.password)
      .then(() => {
        // Success
        this.status = 'success';
        this.processing = false;
        // console.log('password reset was successful')
        this.feedback = 'Your password has successfully been reset. Please try to log into your HeyBuddy Club app.'
      })
      .catch((err) =>{
        // Invalid code
        this.processing = false
        console.log(err)
      })

    }else{
      this.feedback == 'Passwords do not match.'
    }
  }
},
created(){
  // this.resetPassword()
  this.verifyPasswordCode(this.reset_token)
}
}
</script>
<style scoped>
#ResetPassword{
  position: fixed;
  top:50%;
  left:50%;
  transform: translateX(-50%) translateY(-50%);
  text-align: left;
  width: 86%;
  max-width: 900px;
  z-index: 5;
  background-color:#fff;
  border-radius: 40px 40px 0px 0px;
  padding: .1rem 3rem;
}
.title-text{
  color: var(--primary);
  font-size: 2rem;
  margin: 1rem auto;
}
.sub-auth-text{
  font-size: 1rem;
  margin: .3rem auto;
  color: #B4BDD5;
}
.signup-area{
  margin-bottom: 4rem;
}
.login-form{
  text-align: center;
  margin-top: 2rem
}
.input-group{
  display:flex;
  border-radius: 10px;
  border: 3px solid var(--primary);
  padding: .6rem 2rem;
  padding-left: 1rem;
  padding-right: 0rem;
  width: 100%;
  min-width: 150px;
  min-height: 1.5rem;
  margin: 1rem 0;
  transition: 1s;
}
.input-icon{
  width: 2rem;
}
.long{
  background-repeat: no-repeat;
  background-position: right center;
  background-origin: content-box;
  background-size: 1.5rem 1.5rem;
}
.login-input{
  border:none;
  border-left: 1.5px solid #d6d6d6;
  padding: 0rem 2rem;
  padding-left: 1rem;
  padding-right: 0rem;
  width: 100%;
  font-size: 1rem;
  /* margin: .2rem 0; */
  margin-left: .3rem;
  transition: 1s;
}
.contact-text{
  color: #FB9E05;
  text-decoration: none;
}
.selected{
  left:70%;
}
.input-checkbox{
  opacity: 0;
  position: absolute;
  right: 0;
  z-index: 3;
  width:  4rem;
  height:  1.3rem;
  cursor:pointer;
}
.login-btn{
  background-color: var(--primary);
  text-align:center;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  padding: .5rem 1rem;
  color: #fff;
  width: 80%;

  min-width: 150px;
  height: 3rem;
  margin: 2rem auto;
  cursor: pointer;
  transition: 1s;
}
.signup-text{
  font-size: .8rem;
}
.signup-link,
.signup-link:visited{
  text-decoration: none;
  color: var(--link-light);
}
.processing-box{
  display: flex;
  justify-content:center;
  align-items:center;
  width: 90%;
  margin: 2rem auto;
}
.processing-box img{
  width: 20%;
}
.danger{
  color: #ff6666;
}
.feedback{
  color: #33cc33;
}
@media only screen and (max-width: 400px) {
  .title-text{font-size: 1.8rem;}
  .input-group{margin: .51rem 0; padding: .4rem .8rem;}
  .login-btn{  height: 2.4rem; margin-top: .2rem;}
  .login-form{margin-top: .2rem}
}
</style>
